import { Outlet } from "react-router-dom"

import ChannelPanel from "./ChannelPanel"
import InfoPanel from "./InfoPanel"
import SurveysModal from "./surveys/SurveysModal"
import { requireAuth } from "../../util/auth"
import useSetInitialClient from "../clients/hooks/useSetInitialClient"

const HomePage = () => {
  // If there is no current coaching group, visit the first one
  useSetInitialClient()
  return (
    <div className="flex flex-row flex-1">
      <ChannelPanel />
      <Outlet />
      <InfoPanel />
      <SurveysModal />
    </div>
  )
}

const HomePageWithAuth = requireAuth(HomePage)
export default HomePageWithAuth
